export default __webpack_public_path__ + "static/media/glasses-2.73b70af7.svg";